import script from "./PgLoanOptionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgLoanOptionsModal.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/professional-grad/loanConfiguration.css?vue&type=style&index=0&id=7f845510&scoped=true&lang=css"
import "@/styles/professional-grad/substep-1.css?vue&type=style&index=1&id=7f845510&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f845510"]])

export default __exports__